export const headerNav = [
  { label: '首页', href: '#hero' },
  { label: '常见问答', href: '#faq' },
  { label: '视频深扒', href: '#media' },
  { label: 'APP独家', href: '#app' },
  { label: '最新快讯', href: '#updates' },
];

export const heroData = {
  tag: '🔥 今日热瓜',
  h1: '吃瓜网每日大赛 — 娱乐圈争议事件深度起底',
  slogan: '明星黑料不缺席，每天一口新鲜瓜',
  intro: '吃瓜网每日大赛是全网最硬核的娱乐圈争议事件聚合平台，每日追踪明星黑料、艺人黑历史与内幕扒皮，覆盖塌房实录、绯闻深扒、合约纠纷、税务风波等全品类负面新闻。我们不做无脑搬运，每条线索都经过多方交叉验证，确保你吃到的每一口瓜都有料、有据、有深度。当前站内已收录超过2000条艺人争议记录，日均更新30+条新瓜，是吃瓜群众的首选情报站。',
  stats: [
    { value: '2000+', label: '争议事件收录' },
    { value: '日均30+', label: '新瓜更新' },
    { value: '7×24h', label: '全天候追踪' },
  ],
  ctaPrimary: { text: '开始吃瓜', href: '#topics' },
  ctaSecondary: { text: '了解我们', href: '#about' },
};

export const topicsData = [
  { tag: '税务风波', heat: '9.8万讨论', href: '#topics' },
  { tag: '出轨实锤', heat: '8.5万讨论', href: '#topics' },
  { tag: '合约纠纷', heat: '7.2万讨论', href: '#topics' },
  { tag: '人设崩塌', heat: '6.9万讨论', href: '#topics' },
  { tag: '片场耍大牌', heat: '5.4万讨论', href: '#topics' },
  { tag: '私生子传闻', heat: '4.8万讨论', href: '#topics' },
  { tag: '学历造假', heat: '4.1万讨论', href: '#topics' },
  { tag: '选秀黑幕', heat: '3.7万讨论', href: '#topics' },
  { tag: '代言翻车', heat: '3.3万讨论', href: '#topics' },
  { tag: '综艺剧本', heat: '2.8万讨论', href: '#topics' },
  { tag: '天价片酬', heat: '2.4万讨论', href: '#topics' },
];

export const appData = {
  title: '吃瓜网APP — 一手黑料推送',
  description: '下载吃瓜网APP，开启实时推送模式。明星塌房、艺人翻车第一时间弹窗通知，离线也能刷瓜，暗黑模式护眼深扒到天亮。支持iOS和Android双平台，已有超过50万吃瓜群众在使用。',
  features: ['实时推送', '离线阅读', '暗黑模式', '无限收藏'],
  qrLabel: '扫码下载APP',
  badgeApple: 'App Store',
  badgeAndroid: 'Google Play',
};

export const commentsData = [
  {
    avatar: '匿',
    name: '吃瓜一线群众',
    time: '2小时前',
    content: '这个站太狠了，每天上班第一件事就是打开看看有没有新瓜，比微博热搜还刺激。上次那个顶流税务风波的扒皮贴，细节多到让人头皮发麻。',
    likes: 1283,
  },
  {
    avatar: '匿',
    name: '娱乐圈观察员',
    time: '5小时前',
    content: '追了吃瓜网快半年了，最大的感受就是这里的信息比别的平台快不止一档，而且每条都有时间线和证据链，不是那种开局一张图剩下全靠编的野鸡号。',
    likes: 967,
  },
  {
    avatar: '匿',
    name: '深夜吃瓜人',
    time: '8小时前',
    content: '昨晚那个男团成员的合约纠纷深度扒皮看得我失眠，原来选秀出道背后的水这么深。感谢吃瓜网让我看清了娱乐圈的真实面目，继续蹲更多猛料。',
    likes: 745,
  },
];

export const faqData = [
  {
    q: '吃瓜网的信息来源可靠吗？',
    a: '我们的每条爆料都经过团队多方交叉验证，信息来源包括公开法律文书、工商登记信息、权威媒体报道以及多位行业知情人士。我们不发布未经核实的单方面传言，每条争议事件都附有详实的证据链和时间线。',
  },
  {
    q: '如何第一时间收到最新爆料？',
    a: '下载吃瓜网APP并开启推送通知，重大爆料会在第一时间弹窗提醒。同时建议关注我们的社交媒体账号，每日精选内容也会同步推送。网页端每小时自动刷新热门话题榜单。',
  },
  {
    q: '可以投稿爆料吗？',
    a: '欢迎知情人士通过页面底部的联系方式投稿。我们承诺对所有爆料人信息严格保密，投稿内容经核实后将标注来源级别发布。重大独家爆料提供者有丰厚奖励。',
  },
  {
    q: '吃瓜网每日更新多少内容？',
    a: '目前日均更新30条以上争议事件相关内容，包括新瓜首发、事件跟进、深度扒皮和舆情分析。周末和节假日不休，重大突发爆料随时插更。',
  },
  {
    q: '如何搜索特定艺人的黑历史？',
    a: '页面顶部的搜索功能支持按艺人姓名、事件关键词和话题标签进行检索。我们已收录超过2000条艺人相关争议记录，搜索范围覆盖事件名称、涉事艺人、发布时间和内容全文。',
  },
];

export const rankingData = [
  { rank: 1, title: '顶流歌手税务风波全记录：从爆红到翻车的180天', heat: '🔥 10万+阅读', tag: '税务' },
  { rank: 2, title: '某选秀冠军合约纠纷：天价违约金背后的资本博弈', heat: '🔥 8.7万阅读', tag: '合约' },
  { rank: 3, title: '三字女星离婚内幕：从恩爱夫妻到法庭对峙', heat: '🔥 7.2万阅读', tag: '婚姻' },
  { rank: 4, title: '综艺咖人设崩塌实录：镜头前后的巨大反差', heat: '🔥 6.5万阅读', tag: '人设' },
  { rank: 5, title: '世家小生学历门：名校光环背后的造假产业链', heat: '🔥 5.8万阅读', tag: '学历' },
];

export const mediaData = [
  {
    title: '深度扒皮：顶流男星的商业版图与税务迷局',
    duration: '18:24',
    views: '56.2万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20entertainment%20industry%20scandal%20with%20newspaper%20clippings%20and%20magnifying%20glass%2C%20dark%20red%20and%20cream%20color%20palette%2C%20editorial%20style%2C%20dramatic%20lighting%2C%20contrasting%20shadows%2C%20mysterious%20atmosphere%2C%20clean%20composition&width=800&height=450&seq=media-card-01&orientation=landscape',
  },
  {
    title: '合约陷阱揭秘：选秀艺人为何频频对簿公堂',
    duration: '22:10',
    views: '43.8万',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20interpretation%20of%20legal%20documents%20and%20broken%20contracts%20in%20showbiz%2C%20warm%20red%20and%20gold%20tones%2C%20dramatic%20contrast%2C%20editorial%20photography%20style%2C%20clean%20modern%20aesthetic%2C%20soft%20shadows&width=800&height=450&seq=media-card-02&orientation=landscape',
  },
  {
    title: '人设经济学：明星形象崩塌的72小时舆情链',
    duration: '15:45',
    views: '38.1万',
    image: 'https://readdy.ai/api/search-image?query=Conceptual%20illustration%20of%20celebrity%20reputation%20collapse%20with%20shattered%20mirrors%20and%20spotlight%2C%20deep%20burgundy%20and%20cream%20palette%2C%20dramatic%20cinematic%20lighting%2C%20editorial%20style%2C%20mysterious%20mood&width=800&height=450&seq=media-card-03&orientation=landscape',
  },
  {
    title: '饭圈战争史：从控评到线下冲突的疯狂内卷',
    duration: '20:33',
    views: '31.5万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20art%20depicting%20social%20media%20chaos%20and%20fan%20culture%20intensity%2C%20warm%20coral%20and%20dark%20red%20accents%2C%20glitch%20effects%2C%20modern%20editorial%20style%2C%20clean%20composition%2C%20dramatic%20lighting&width=800&height=450&seq=media-card-04&orientation=landscape',
  },
  {
    title: '天后黄昏：当红女星的代言帝国为何一夜崩塌',
    duration: '25:08',
    views: '29.7万',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20visualization%20of%20celebrity%20endorsement%20crisis%20with%20falling%20brand%20logos%20and%20spotlight%2C%20rich%20burgundy%20and%20cream%20color%20scheme%2C%20dramatic%20editorial%20aesthetic%2C%20soft%20shadows%2C%20mysterious%20ambiance&width=800&height=450&seq=media-card-05&orientation=landscape',
  },
];

export const carouselData = [
  {
    title: '2024年度塌房大盘点',
    subtitle: '12位顶流艺人的至暗时刻',
    description: '从年初到年尾，娱乐圈的塌房事件密度创下历史新高。我们整理了最具代表性的12起塌房事件，还原每一个从神坛跌落的瞬间。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20illustration%20of%20celebrity%20fall%20from%20grace%20with%20spotlight%20fading%2C%20warm%20burgundy%20and%20dark%20red%20gradient%20background%2C%20editorial%20cinematic%20style%2C%20dramatic%20shadows%2C%20mysterious%20elegant%20mood&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '年度专题',
  },
  {
    title: '选秀经济学的崩塌',
    subtitle: '从全民狂欢到无人问津',
    description: '选秀节目曾是各大平台的流量密码，如今却成了烫手山芋。我们从资本、政策和舆论三个维度解析选秀模式的全面溃败。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20art%20showing%20stage%20curtains%20falling%20and%20microphones%20scattered%2C%20deep%20burgundy%20and%20cream%20contrast%2C%20editorial%20cinematic%20style%2C%20dramatic%20lighting%2C%20mysterious%20elegant%20composition&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '深度分析',
  },
  {
    title: '税务风暴2.0',
    subtitle: '第二波娱乐圈税务稽查全纪实',
    description: '继第一波影视行业税务整顿后，新一轮更严格的稽查正在席卷整个娱乐圈。我们梳理了已经曝光的案例和潜在的雷区。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20conceptual%20illustration%20of%20financial%20investigation%20with%20documents%20and%20magnifying%20glass%2C%20rich%20dark%20red%20and%20warm%20gold%20palette%2C%20editorial%20cinematic%20lighting%2C%20mysterious%20professional%20mood&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '重磅追踪',
  },
  {
    title: '饭圈文化的双面',
    subtitle: '天使OR魔鬼？',
    description: '饭圈文化催生了惊人的商业价值，也制造了无数社会争议。我们深入探访了多位前粉头和脱粉人士，还原真实的饭圈生态。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dual%20faced%20masks%20illustration%20representing%20fan%20culture%20complexity%2C%20coral%20red%20and%20cream%20contrast%2C%20editorial%20dramatic%20style%2C%20soft%20shadows%2C%20mysterious%20thoughtful%20mood&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '社会观察',
  },
  {
    title: '天价片酬背后的秘密',
    subtitle: '一个亿一部戏的钱都去了哪',
    description: '明星天价片酬早已不是新闻，但片酬背后的利益分配链条却鲜为人知。我们从合同、税务和资本层面层层剥开。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20money%20flow%20and%20film%20industry%20behind%20scenes%2C%20dark%20burgundy%20and%20gold%20color%20scheme%2C%20editorial%20cinematic%20lighting%2C%20dramatic%20mysterious%20atmosphere&width=1200&height=600&seq=carousel-05&orientation=landscape',
    tag: '内幕深扒',
  },
  {
    title: '代言人翻车险',
    subtitle: '品牌方如何应对明星危机',
    description: '明星代言翻车已成品牌方的噩梦。从连夜删物料到天价索赔，品牌公关团队的72小时危机应对手册首次公开解析。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20visual%20of%20brand%20logos%20going%20dark%20and%20crisis%20management%20in%20entertainment%20industry%2C%20deep%20red%20and%20cream%20palette%2C%20editorial%20dramatic%20style%2C%20mysterious%20professional%20tone&width=1200&height=600&seq=carousel-06&orientation=landscape',
    tag: '商业解密',
  },
];

export const featuresData = [
  {
    icon: 'ri-search-eye-line',
    title: '深度扒皮',
    description: '每条爆料附带完整时间线和证据链，不做表面吃瓜，只做有深度的娱乐调查报道。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '实时追踪',
    description: '重大事件发生后15分钟内发布快讯，2小时内完成深度梳理，让你永远快人一步。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '交叉验证',
    description: '每篇内容至少3个独立信息源交叉确认，杜绝单方面传言和恶意造谣。',
  },
  {
    icon: 'ri-archive-line',
    title: '海量归档',
    description: '2000+条争议事件永久存档，支持按艺人、时间和标签多维度检索翻旧账。',
  },
  {
    icon: 'ri-user-voice-line',
    title: '匿名投稿',
    description: '严格的爆料人保护机制，知情人士可安全投稿，重大独家线索提供丰厚奖励。',
  },
];

export const contactData = {
  title: '爆料投稿与合作',
  description: '如果你是知情人士，手握娱乐圈猛料却无处可发，我们是你最安全的选择。投稿全程加密，爆料人信息永不外泄。商务合作与媒体采访也欢迎通过以下方式联系。',
  items: [
    { icon: 'ri-mail-line', label: '爆料邮箱', value: 'tips@chigua-daily.com' },
    { icon: 'ri-chat-smile-2-line', label: '官方微博', value: '@吃瓜网每日大赛' },
    { icon: 'ri-wechat-line', label: '微信公众号', value: '吃瓜网每日大赛' },
  ],
};

export const aboutData = {
  title: '关于吃瓜网每日大赛',
  paragraphs: [
    '吃瓜网每日大赛成立于2023年，是国内领先的娱乐圈争议事件聚合与深度分析平台。我们坚持"有料、有据、有深度"的内容理念，不制造谣言，只搬运和核实已经存在的争议信息。',
    '团队由资深娱乐记者、数据分析师和舆情研究专家组成，全天候追踪娱乐圈动态。我们的使命是让每一位吃瓜群众都能享用到高质量、有营养的"瓜"，而不是来路不明的"假瓜烂瓜"。',
    '截至目前，平台已累计收录超过2000条艺人相关争议事件，日均独立访客超过30万，是中文互联网最具影响力的娱乐争议内容平台之一。',
  ],
};

export const updatesData = [
  {
    time: '3分钟前',
    title: '快讯：某二字顶流被拍到深夜出入税务局',
    summary: '网友在税务局门口拍到疑似某顶流男星的身影，引发税务问题猜测。',
    tag: '突发',
  },
  {
    time: '28分钟前',
    title: '更新：选秀冠军合约纠纷案今日开庭',
    summary: '法院门口聚集大量媒体和粉丝，案件涉及金额据传超过5000万。',
    tag: '追踪',
  },
  {
    time: '1小时前',
    title: '爆料：某综艺常驻嘉宾片场耍大牌被剪镜头',
    summary: '据节目组工作人员透露，该嘉宾多次迟到并拒绝配合录制。',
    tag: '独家',
  },
  {
    time: '2小时前',
    title: '深扒：三字女星离婚协议细节曝光',
    summary: '财产分割条款显示多处不寻常安排，引发专业人士质疑。',
    tag: '深扒',
  },
  {
    time: '4小时前',
    title: '溯源：某男团成员学历造假产业链浮出水面',
    summary: '从中介到学校到艺人公司的完整造假链条被逐一揭开。',
    tag: '独家',
  },
  {
    time: '6小时前',
    title: '跟踪：天后代言品牌集体解约事件最新进展',
    summary: '已有7个品牌宣布解约，律师称索赔总额可能突破亿元。',
    tag: '追踪',
  },
  {
    time: '9小时前',
    title: '回顾：2024上半年娱乐圈十大争议事件',
    summary: '从塌房到翻车，盘点今年上半年最具冲击力的娱乐争议瞬间。',
    tag: '盘点',
  },
  {
    time: '12小时前',
    title: '快讯：某古装剧男二被爆与已婚制片人有染',
    summary: '多位剧组人员证实两人关系异常，制片人丈夫已聘请律师。',
    tag: '爆料',
  },
];

export const cardsData = [
  {
    title: '顶流男星商业帝国崩塌始末',
    excerpt: '从年入过亿到被全面封杀，他究竟踩了多少红线？',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20illustration%20of%20falling%20empire%20in%20entertainment%20industry%2C%20deep%20burgundy%20and%20dark%20tones%2C%20editorial%20style%2C%20mysterious%20mood%2C%20soft%20dramatic%20lighting&width=800&height=500&seq=cards-01&orientation=landscape',
    date: '2024-07-28',
    reads: '12.3万',
  },
  {
    title: '选秀出道五年后的生存现状调查',
    excerpt: '当年的C位如今在做什么？我们追踪了50位选秀艺人的去向。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20visual%20of%20multiple%20spotlights%20dimming%20on%20a%20stage%2C%20warm%20coral%20and%20cream%20palette%2C%20editorial%20dramatic%20style%2C%20soft%20nostalgic%20lighting%2C%20clean%20composition&width=800&height=500&seq=cards-02&orientation=landscape',
    date: '2024-07-26',
    reads: '9.8万',
  },
  {
    title: '娱乐圈"关系户"图谱：谁是谁的人',
    excerpt: '一张图看懂娱乐圈背后的资本关系网和派系格局。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20network%20connections%20illustration%20representing%20entertainment%20industry%20relationships%2C%20rich%20red%20and%20dark%20tones%2C%20editorial%20style%2C%20mysterious%20atmosphere%2C%20clean%20design&width=800&height=500&seq=cards-03&orientation=landscape',
    date: '2024-07-24',
    reads: '8.5万',
  },
  {
    title: '片场黑话词典：娱乐圈潜规则的暗语世界',
    excerpt: '从"带资进组"到"阴阳合同"，那些圈内人才懂的暗语全解读。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20conceptual%20art%20of%20hidden%20messages%20and%20secrets%20in%20film%20industry%2C%20dark%20burgundy%20and%20cream%20contrast%2C%20editorial%20dramatic%20style%2C%20mysterious%20mood&width=800&height=500&seq=cards-04&orientation=landscape',
    date: '2024-07-22',
    reads: '7.6万',
  },
  {
    title: '从顶流到素人：那些一夜消失的明星去哪了',
    excerpt: '我们对近三年突然消失的15位艺人进行了深入追踪调查。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20disappearing%20silhouettes%20in%20spotlight%2C%20warm%20coral%20and%20dark%20red%20palette%2C%20editorial%20dramatic%20style%2C%20mysterious%20elegant%20mood%2C%20clean%20composition&width=800&height=500&seq=cards-05&orientation=landscape',
    date: '2024-07-20',
    reads: '11.1万',
  },
];

export const indexData = [
  { label: '税务风波专题', count: '47篇', href: '#index' },
  { label: '合约纠纷档案', count: '38篇', href: '#index' },
  { label: '出轨实锤合集', count: '52篇', href: '#index' },
  { label: '学历造假追踪', count: '23篇', href: '#index' },
  { label: '人设崩塌记录', count: '61篇', href: '#index' },
  { label: '选秀黑幕深扒', count: '35篇', href: '#index' },
  { label: '代言翻车事件', count: '29篇', href: '#index' },
];

export const footerData = {
  intro: '吃瓜网每日大赛 — 全网最硬核的娱乐圈争议事件聚合平台。每日更新明星黑料、艺人黑历史与娱乐圈丑闻，坚持有料、有据、有深度的内容理念。吃瓜网黑料，让每一口瓜都值得回味。',
  links: [
    { label: '常见问答', href: '#faq' },
    { label: '视频深扒', href: '#media' },
    { label: 'APP独家', href: '#app' },
    { label: '最新快讯', href: '#updates' },
    { label: '深度扒皮', href: '#features' },
    { label: '热点话题', href: '#topics' },
  ],
  partnersLabel: '合作伙伴',
};